/**
 * @generated SignedSource<<77407fc992c69e6393ebd11cc57c954d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceRenderer_piece$data = {
  readonly id: string;
  readonly output_storage_name: string | null;
  readonly file: {
    readonly notes: ReadonlyArray<{
      readonly bulb_id: string;
      readonly left_handed: boolean;
      readonly note_start: number;
      readonly " $fragmentSpreads": FragmentRefs<"PieceRendererNote_note">;
    }>;
  } | null;
  readonly " $fragmentType": "PieceRenderer_piece";
};
export type PieceRenderer_piece$key = {
  readonly " $data"?: PieceRenderer_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRenderer_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceRenderer_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "output_storage_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MusicPieceFileNote",
          "kind": "LinkedField",
          "name": "notes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bulb_id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "left_handed",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "note_start",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PieceRendererNote_note"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "94291b7487f646cbc6ea37c0e7364754";

export default node;
